module.exports = __webpack_public_path__ + "media/images/circle-66e7dbfb57e077864d12cb74f408ab6f.svg";